import * as E from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/pipeable'
import * as t from 'io-ts'

import { sha256 } from 'js-sha256'
import jwtDecode from 'jwt-decode'

import {
  AuthMetadata,
  AuthService
} from '@espoon-voltti/nuora-app-common/services/auth'

import { authApi } from './api'

const TokenPayload = t.type({
  sub: t.string,
  given_name: t.string,
  family_name: t.string
})

export class SfiAuthService implements AuthService {
  public getAuth = (): Promise<AuthMetadata> =>
    authApi.getToken().then((token) =>
      pipe(
        TokenPayload.decode(jwtDecode(token.value)),
        E.map((tokenData) => ({
          givenName: tokenData.given_name,
          familyName: tokenData.family_name,
          ssnHash: sha256(tokenData.sub)
        })),
        (maybeAuth): AuthMetadata => {
          if (E.isRight(maybeAuth)) {
            return maybeAuth.right
          }
          throw new Error('Unable to decode token')
        }
      )
    )
}
